import React from "react";

import {
  FormControl,
  InputLabel,
  Select as MaterialSelect,
} from "@mui/material";

// import { withStyles } from '@mui/styles';

// import style from './selectStyle';

import { computed } from "mobx";
import * as utils from '@intrasync/utils';
import { injectPropsChildren } from 'shared/common/react';
import injectStores from "../RootStore/injectStores";

interface SelectProps {
  onChange?: (newValue: string | string[]) => void;
  multiple?: boolean;
  label: string;
  value: string | string[];
  children: React.ReactNode;
  fullWidth?: boolean;
  white?: boolean;
  disabled?: boolean;
  size?: "medium" | "small";
  // classes: any;
}

/**
 * Helper function to recursively flatten React children into an array of elements.
 */
const flattenChildren = (nodes: React.ReactNode): React.ReactElement[] => {
  const result: React.ReactElement[] = [];
  const process = (node: React.ReactNode) => {
    if (Array.isArray(node)) {
      node.forEach(process);
    } else if (React.isValidElement(node)) {
      result.push(node);
    }
  };
  process(nodes);
  return result;
};

/**
 * Helper function to find the display value from children based on selected value.
 * Looks for a child with a matching `value` prop and returns its label/data-value prop,
 * or falls back to children prop if neither is present.
 */
const getDisplayValue = (children: React.ReactNode, selectedValue: string): string => {
  const childArray = flattenChildren(children);
  for (const child of childArray) {
    const childValue = child.props.value;
    if (String(childValue) === String(selectedValue)) {
      // Check for label first, then data-value, then children
      const label = child.props.label;
      if (label) {
        return label;
      }
      const childDataValue = child.props['data-value'];
      if (childDataValue) {
        return childDataValue;
      }
      // Fall back to children if it's a string
      const childChildren = child.props.children;
      if (typeof childChildren === 'string') {
        return childChildren;
      }
    }
  }
  return selectedValue;
};

class Select extends React.PureComponent<SelectProps> {
  static defaultProps = {
    fullWidth: true,
    multiple: false,
    white: false,
    disabled: false,
    size: "medium",
    onChange: null, //Added a default onChange prop
  };

  handleChange = (newValue: string | string[]) => {
    const { onChange, multiple } = this.props;
    if (!newValue || newValue === "None") {
      return onChange ? onChange("") : null;
    }
    if (multiple && Array.isArray(newValue)) {
      return onChange ? onChange(newValue.slice().sort()) : null;
    }
    return onChange ? onChange(newValue) : null;
  };
  render() {
    const {
      // classes,
      label,
      value,
      children,
      fullWidth,
      multiple,
      // white,
      disabled,
      size,
    } = this.props;
    const selectId = utils.uuid();

    const childrenWithProps = injectPropsChildren(children, {
      currentValue: value,
    });
    const renderValue = computed(() => {
      if (!value || value === '') return null;
      if (multiple && Array.isArray(value)) {
        const displayValues = value.map(v => getDisplayValue(children, v));
        return displayValues.join(", ");
      }
      return getDisplayValue(children, value as string);
    }).get();

    const selectValue = computed(() => {
      if (multiple && !Array.isArray(value)) return [value];
      return value;
    }).get();
    return (
      <FormControl
        key={`${selectId}-control`}
        fullWidth={fullWidth}
        // className={`${classes.selectFormControl} ${white ? classes.white : ''}`}
        variant={size === "small" ? "outlined" : "standard"}
        disabled={disabled}
        size={size}
      >
        <InputLabel
          id={`${selectId}-label`}
          // className={`${classes.selectLabel} ${
          //   white && size !== 'small' ? classes.whiteLabel : ''
          // } ${size === 'small' ? classes.smallLabelPadding : ''}`}
        >
          {label}
        </InputLabel>
        <MaterialSelect
          renderValue={() => renderValue || "None"}
          labelId={`${selectId}-label`}
          // MenuProps={{
          //   className: classes.selectMenu,
          // }}
          // classes={{
          //   select:
          //     size === 'small' ? classes.selectSmall : classes.selectMedium,
          // }}
          multiple={multiple}
          value={selectValue}
          onChange={(e) => this.handleChange(e?.target?.value || "")}
        >
          {childrenWithProps}
        </MaterialSelect>
      </FormControl>
    );
  }
}

export default injectStores(Select);
